module.exports = __webpack_public_path__ + "static/media/mapbox-fullscreen.28cfb917.svg";